import { siteIntro } from "@/mocks/siteContent";

export default function AboutSection() {
  return (
    <section id="about" className="scroll-mt-16 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-8xl px-4 md:px-8">
        <div className="grid gap-10 lg:grid-cols-[1.3fr_1fr]">
          <div>
            <span className="text-sm font-medium text-accent-700">关于本站</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{siteIntro.title}</h2>
            <div className="mt-5 space-y-4">
              {siteIntro.paragraphs.map((paragraph) => (
                <p key={paragraph} className="text-sm leading-relaxed text-foreground-600 md:text-base">
                  {paragraph}
                </p>
              ))}
            </div>
          </div>

          <div className="grid gap-4 sm:grid-cols-2">
            {siteIntro.highlights.map((item) => (
              <div key={item.title} className="rounded-lg border border-background-200 bg-background-100 p-5">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}